export const flavors = {
  raised: "RAISED",
  spotlight: "SPOTLIGHT",
};

export const verticalSnaps = {
  top: "TOP",
  bottom: "BOTTOM",
};

export const horizontalSnaps = {
  left: "LEFT",
  right: "RIGHT",
  center: "CENTER",
};
